/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SaveUserApiKeyRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {SaveUserApiKeyResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const saveUserApiKey = (request: SaveUserApiKeyRequest, options?: CashRequestOptions) => post<SaveUserApiKeyRequest, SaveUserApiKeyResponse>("/2.0/cash/save-user-api-key", request, {...options, rejectOnError: true })